const swiper = () => {
	let disable = false;
	const initialSlide = 0;

	const swiper = new Swiper('.swiper', {
		speed: 600,
		spaceBetween: 1,
		centeredSlides: true,
		slideToClickedSlide: true,
		grabCursor: true,
		loop: true,
		initialSlide: initialSlide,
		breakpoints: {
			320: {
				slidesPerView: 4,
			},
			768: { slidesPerView: 'auto', spaceBetween: 9 },
		},
	});
	let previewImg = document.getElementById('album-preview');
	let swiperWrapper = document.getElementById('swiper');
	let swiperSlides = document.getElementsByClassName('swiper-slide');
	const transitionTime = 800;

	// добавить датасеты на враппер превью
	swiperWrapper.addEventListener('click', () => {
		// проверка на случай, когда много кликов и settimeout не успевает сработать
		if (disable) {
			return;
		}
		disable = true;
		let nextPreviewImgTEST = document.getElementById('album-preview-next');
		if (nextPreviewImgTEST) nextPreviewImgTEST.remove();
		//

		previewImg = document.getElementById('album-preview');
		const albumPreviewWrapper = document.getElementById(
			'album-preview-wrapper',
		);
		const appendPreviewImg = document.createElement('img');
		if (!previewImg) {
			albumPreviewWrapper.appendChild(appendPreviewImg);
		}

		const appendNextPreviewImg = document.createElement('img');
		appendPreviewImg.id = 'album-preview';
		appendNextPreviewImg.id = 'album-preview-next';
		albumPreviewWrapper.appendChild(appendNextPreviewImg);
		// добавление dataset на враппер

		albumPreviewWrapper.dataset.numberOfSongs = JSON.parse(
			swiper.clickedSlide.dataset.songsList,
		).length;
		albumPreviewWrapper.dataset.activeSong = 1;
		albumPreviewWrapper.dataset.listSongs =
			swiper.clickedSlide.dataset.songsList;
		albumPreviewWrapper.dataset.albumId = JSON.parse(
			swiper.clickedSlide.dataset.albumId,
		);
		albumPreviewWrapper.dataset.albumTitle =
			swiper.clickedSlide.dataset.albumTitle;

		const albumTitleNode = document.getElementById('album-preview-title');
		const albumTitleMobileNode = document.getElementById(
			'album-preview-title-mobile',
		);

		const albumTitle = JSON.parse(swiper.clickedSlide.dataset.albumTitle);
		
		// Разбиваем название на две строки для первого альбома
		let titleWithSpan;
		if (albumTitle.includes('Far&High')) {
			titleWithSpan = `<span>Far&High</span><span>& pizzaaftersex</span>`;
		} else {
			titleWithSpan = `<span> ${albumTitle} </span>`;
		}

		albumTitleNode.innerHTML = titleWithSpan;
		albumTitleMobileNode.innerHTML = titleWithSpan;

		const trackList = JSON.parse(albumPreviewWrapper.dataset.listSongs);
		const trackListNode = document.getElementById('album-tracklist');
		const trackListMobileNode = document.getElementById(
			'album-tracklist-mobile',
		);

		trackListNode.innerHTML = '';
		trackListMobileNode.innerHTML = '';
		// console.log('tracklist', trackList);
		Array.from(trackList).forEach((track, index) => {
			const song = document.createElement('li');
			if (index === 0) {
				song.classList.add('active-song');
			} else {
				song.classList.remove('active-song');
			}

			song.classList.add('albums__item-song');
			song.innerText = track.title;
			trackListNode.appendChild(song.cloneNode('true'));
			trackListMobileNode.appendChild(song);
		});

		// обновить трек лист
		// добавление dataset на враппер конец

		const nextPreviewImg = document.getElementById('album-preview-next');
		let imgSrc = swiper.clickedSlide.children[0].src;
		nextPreviewImg.src = imgSrc;

		window.requestAnimationFrame(() => {
			if (previewImg) {
				previewImg.style.setProperty(
					'transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty(
					'-webkit-transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty(
					'-moz-transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty(
					'-o-transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty('transform', 'translateX(-100%)');
			}
		});

		window.requestAnimationFrame(() => {
			nextPreviewImg.style.setProperty(
				'transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			nextPreviewImg.style.setProperty(
				'-webkit-transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			nextPreviewImg.style.setProperty(
				'-moz-transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			nextPreviewImg.style.setProperty(
				'-o-transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			setTimeout(() => {
				nextPreviewImg.style.setProperty('transform', 'translateX(-100%)');
			}, 0);
		});

		setTimeout(() => {
			previewImg.remove();
			nextPreviewImg.style.removeProperty('transition');
			nextPreviewImg.style.removeProperty('transform');
			nextPreviewImg.id = 'album-preview';
			disable = false;
		}, transitionTime);
	});
	return swiper;
};

export default swiper;
